<h2 mat-dialog-title>Audit Changes</h2>

<mat-dialog-content>
  <div class="meta">
    <div class="meta-item">
      <span class="meta-label">Entity</span>
      <span class="meta-value">{{ entry.entityType }}</span>
    </div>
    <div class="meta-item">
      <span class="meta-label">Entity Id</span>
      <span class="meta-value mono">{{ entry.entityId }}</span>
    </div>
    <div class="meta-item">
      <span class="meta-label">Action</span>
      <span class="type-badge" [ngClass]="'action-' + entry.action.toLowerCase()">{{ entry.action }}</span>
    </div>
    <div class="meta-item">
      <span class="meta-label">User</span>
      <span class="meta-value">{{ entry.changedBy }}</span>
    </div>
    <div class="meta-item">
      <span class="meta-label">When</span>
      <span class="meta-value">{{ entry.changedAt | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
    </div>
    @if (entry.owningEntityType) {
      <div class="meta-item">
        <span class="meta-label">Owner</span>
        <span class="meta-value">{{ entry.owningEntityType }}</span>
      </div>
    }
  </div>

  @if (parseError) {
    <pre class="raw-changes">{{ rawChanges }}</pre>
  } @else if (rows.length === 0) {
    <p class="empty">No field changes recorded.</p>
  } @else {
    <table mat-table [dataSource]="rows" class="changes-table">
      <ng-container matColumnDef="field">
        <th mat-header-cell *matHeaderCellDef>Field</th>
        <td mat-cell *matCellDef="let row">{{ row.field }}</td>
      </ng-container>

      <ng-container matColumnDef="old">
        <th mat-header-cell *matHeaderCellDef>Old</th>
        <td mat-cell *matCellDef="let row" class="value-cell">{{ row.old }}</td>
      </ng-container>

      <ng-container matColumnDef="new">
        <th mat-header-cell *matHeaderCellDef>New</th>
        <td mat-cell *matCellDef="let row" class="value-cell">{{ row.new }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="close()">
    <mat-icon>check</mat-icon>
    Close
  </button>
</mat-dialog-actions>
